/**
 * Determines if app layhout should be hidden for a given url
 */

export const shouldHideAppLayout = (url: string) => {
  return url.includes('kommunikasjon/meldingsdetaljer/')
}
